import HttpFactory from '../factory'
import type { Organization, OrganizationV2 } from '../types/organization'

class OrganizationsModule extends HttpFactory<any[]> {
  private RESOURCE_V2 = '/v2/organizations'

  async getV2(id?: string): Promise<any> {
    if (!id) {
      let arr: Organization[] = []
      let nextPageUrl = '?pageSize=1000'
      do {
        await this.call<any>('GET', `${this.RESOURCE_V2}/${nextPageUrl}`).then((response) => {
          arr = arr.concat(response.items)
          nextPageUrl = response.nextPageUrl
        })
      } while (nextPageUrl)
      return arr
    } else return await this.call<any>('GET', `${this.RESOURCE_V2}/${id}`)
  }

  async getRelationship(id: string): Promise<any> {
    return await this.call<any>('GET', `${this.RESOURCE_V2}/${id}/relationships`)
  }

  async saveV2(obj: Partial<OrganizationV2>, displayNameOnly: Boolean): Promise<OrganizationV2> {
    if (obj.id) {
      if (displayNameOnly) {
        return this.call<any>('PATCH', `${this.RESOURCE_V2}/${obj.id}?revision=${obj.revision}`, {
          displayName: obj.displayName,
          description: obj.description,
        })
      } else {
        return this.call<any>('PATCH', `${this.RESOURCE_V2}/${obj.id}?revision=${obj.revision}`, {
          name: obj.name,
          type: obj.type,
          displayName: obj.displayName,
          identifiers: obj.identifiers,
          description: obj.description,
        })
      }
    } else {
      return this.call<any>('POST', `${this.RESOURCE_V2}`, obj)
    }
  }

  async disableReferral(obj: Partial<OrganizationV2>): Promise<OrganizationV2> {
    return this.call<any>('PATCH', `${this.RESOURCE_V2}/${obj.id}?revision=${obj.revision}`, {
      isReferral: obj.isReferral,
    })
  }
}

export default OrganizationsModule
